import React from 'react'

import '../styles/Nav.css'

import Logo from '../img/logo-vocabo-2.png';
import Hamburger from '../img/hamburger.png';
import Close from '../img/close.png'

import { useState , useEffect} from 'react';

import { Link } from 'react-router-dom'
export default function Nav() {
  const [mobileNav , setMobileNav] = useState(false)
  function handleResize() {
      setMobileNav(false)
    }
    window.addEventListener('resize', handleResize)

  

  return (
      <div className='Nav' onReset={() => setMobileNav(!mobileNav)}>
          <div className="Nav-container">
            <div className="Nav-container-logo">
              <Link to='/'><img src={Logo} alt=""/></Link>
            </div>
            <div className='Nav-container-links'>
              <Link to='/'>Home</Link>
              <Link to='/learn'>Learn</Link>
              <Link to='/games'>Games</Link>
              <Link to='/dictionary'>Dictionary</Link>
              <Link to='/favourites'>Favourites</Link>
            </div>
            <div className="hamburger" onClick={() => setMobileNav(!mobileNav)}>
                {mobileNav ? <img src={Close} alt=""/> : <img src={Hamburger} alt="" />}
            </div>
          </div>
          {mobileNav && 
          <div className="mobile-nav">
            <div className='mobile-nav-container'>
              <a href="/">Home</a>
              <a href="/learn">Learn</a>
              <a href="/games">Games</a>
              <a href="/dictionary">Dictionary</a>
              <a href="/favourites">Favourites</a>

              
            </div>
          </div>}
          
         
      </div>
  )
}

  /*  */
    